import { lazy } from 'react';
import withSuspense from '../../helpers/withSuspense';

const WorkQueueList = withSuspense(lazy(() => import('./WorkQueueList.jsx')));

export default WorkQueueList;
